import { zetApi } from '@zet/network'

interface CustomerDetails {
  modeOfIncome: string
  pincode: string
  nameAsPan: string
  annualIncome: string
  gender: string
  employmentType: string
  panNo: string
  fullName: string
  currentOccupation: string
  phoneNumber: number
  dob: number
  customerId: number
  email: string
  bankNamesList: string[]
  subAgentId?: number
}

export type ICustomerDetails = {
  data: CustomerDetails
}

export async function fetchCustomerDetails(customerId: number) {
  const { data } = await zetApi.get<ICustomerDetails>(
    `/customer/getCustomerPrefillDetails?customerId=${customerId}`
  )

  return data?.data
}
